import { getFetch } from '../fetch';
import { apiConfig } from '../config';

export type GetListExamsPointsResponse = [
    {
        studentId: number;
        year: 2022 | 2023;
        examType: 'OGE' | 'EGE'; // сейчас только огэ (31.05.2023)
        points: number; // 0-19 для огэ
        score?: number; // 0-5 (оценки без баллов не может быть)
    }
];

export async function getListExamsPoints(teamId: number): Promise<GetListExamsPointsResponse> {
    const { apiGetListExamsPoints } = apiConfig.getStaticUrls();

    return getFetch(`${apiGetListExamsPoints}${String(teamId)}/`);
}
